import {
  Component,
  Input,
  AfterViewInit,
  OnInit,
  NgModule,
  ModuleWithProviders,
  Inject,
  InjectionToken,
} from '@angular/core';
import { CommonModule } from '@angular/common';


/**
 * Set optional global default values
 */
export interface AdsenseConfig {
  /** adsense account ca-pub-XXXXXXXXXXXXXXXX */
  adClient?: string;
  /** ad slot/number */
  adSlot?: string | number;
  adFormat?: string;
  /** ins element display style */
  display?: string;
  /** ins element height in px */
  width?: number;
  /** ins element width in px */
  height?: number;
  /** used for in-feed ads */
  layout?: string;
  /** used for in-feed ads */
  layoutKey?: string;
}

export const /** @type {?} */ ADSENSE_CONFIG = new InjectionToken<AdsenseConfig>('AdsenseConfig');
export class AdsenseComponent implements OnInit, AfterViewInit {
/**
 * adsense account ca-pub-XXXXXXXXXXXXXXXX
 */
adClient: string;
/**
 * ad slot/number
 */
adSlot: string | number;
   adFormat: string;
/**
 * can be manually set if you need all ads on a page to have same id page-xxx
 */
adRegion = 'page-' + Math.floor(Math.random() * 10000) + 1;
/**
 * ins element display style
 */
display: string;
/**
 * ins element height in px
 */
width: number;
/**
 * ins element width in px
 */
height: number;
/**
 * used for in-feed ads
 */
layout: string;
/**
 * used for in-feed ads
 */
layoutKey: string;
/**
 * @param {?} config
 */
constructor(
private config: AdsenseConfig,
  ) { }
/**
 * @return {?}
 */
ngOnInit() {
    const /** @type {?} */ config = this.config;
/**
 * @template T
 * @param {?} source
 * @param {?} defaultValue
 * @return {?}
 */
function use<T>(source: T, defaultValue: any): T {
      return config && source !== undefined ? source : defaultValue;
    }
    this.adClient = use(this.adClient, config.adClient);
    this.adSlot = use(this.adSlot, config.adSlot);
    this.adFormat = use(this.adFormat, config.adFormat || 'auto');
    this.display = use(this.display, config.display || 'block');
    this.width = use(this.width, config.width);
    this.height = use(this.height, config.height);
    this.layout = use(this.layout, config.layout);
    this.layoutKey = use(this.layoutKey, config.layoutKey);
  }
/**
 * attempts to push the ad twice. Usually if one doesn't work the other
 * will depeding on if the browser has the adsense code cached and
 * if its the first page to be loaded
 * @return {?}
 */
ngAfterViewInit() {
    const /** @type {?} */ res = this.push();
    if (res instanceof TypeError) {
      setTimeout(() => this.push(), 200);
    }
  }
/**
 * @return {?}
 */
push() {
    try {
      const /** @type {?} */ adsbygoogle = window['adsbygoogle'];
      adsbygoogle.push({});
      return true;
    } catch ( /** @type {?} */e) {
      return e;
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ng2-adsense,ng-adsense',
  template: `
  <ins class="adsbygoogle"
    [ngStyle]="{'display': display, 'width.px': width, 'height.px': height }"
    [attr.data-ad-client]="adClient"
    [attr.data-ad-slot]="adSlot"
    [attr.data-ad-format]="adFormat"
    [attr.data-ad-region]="adRegion"
    [attr.data-layout]="layout"
    [attr.data-layout-key]="layoutKey">
  </ins>
  `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: undefined, decorators: [{ type: Inject, args: [ADSENSE_CONFIG, ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'adClient': [{ type: Input },],
'adSlot': [{ type: Input },],
'adFormat': [{ type: Input },],
'adRegion': [{ type: Input },],
'display': [{ type: Input },],
'width': [{ type: Input },],
'height': [{ type: Input },],
'layout': [{ type: Input },],
'layoutKey': [{ type: Input },],
};
}

function AdsenseComponent_tsickle_Closure_declarations() {
/** @type {?} */
AdsenseComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AdsenseComponent.ctorParameters;
/** @type {?} */
AdsenseComponent.propDecorators;
/**
 * adsense account ca-pub-XXXXXXXXXXXXXXXX
 * @type {?}
 */
AdsenseComponent.prototype.adClient;
/**
 * ad slot/number
 * @type {?}
 */
AdsenseComponent.prototype.adSlot;
/** @type {?} */
AdsenseComponent.prototype.adFormat;
/**
 * can be manually set if you need all ads on a page to have same id page-xxx
 * @type {?}
 */
AdsenseComponent.prototype.adRegion;
/**
 * ins element display style
 * @type {?}
 */
AdsenseComponent.prototype.display;
/**
 * ins element height in px
 * @type {?}
 */
AdsenseComponent.prototype.width;
/**
 * ins element width in px
 * @type {?}
 */
AdsenseComponent.prototype.height;
/**
 * used for in-feed ads
 * @type {?}
 */
AdsenseComponent.prototype.layout;
/**
 * used for in-feed ads
 * @type {?}
 */
AdsenseComponent.prototype.layoutKey;
/** @type {?} */
AdsenseComponent.prototype.config;
}

export class AdsenseModule {
/**
 * @param {?=} config
 * @return {?}
 */
static forRoot(config: AdsenseConfig = {}): ModuleWithProviders {
    return {
      ngModule: AdsenseModule,
      providers: [{ provide: ADSENSE_CONFIG, useValue: config }],
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CommonModule],
  exports: [AdsenseComponent],
  declarations: [AdsenseComponent],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AdsenseModule_tsickle_Closure_declarations() {
/** @type {?} */
AdsenseModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AdsenseModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
